import { SpineConstants } from "../constant/ControlConstants";
import { SpriteProperties } from "./SpriteProperties";
/**
 * SpineProperties.ts
 */
export class SpineProperties extends SpriteProperties {
    constructor(id, spriteSheet, position, scale, anchor, rotation) {
        super(id, spriteSheet, position, scale, anchor, rotation);
        this.timeScale = 1;
        this.defaultAnimation = SpineConstants.ANIMATION;
    }
}
//# sourceMappingURL=SpineProperties.js.map